import {
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { SearchFilter } from "@/shared/models/SearchFilter";
import { SectionGroup } from "../../../models/SectionGroup";
import { nanoid } from "nanoid";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { QuerySend } from "@/shared/models/FormQuerySend";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { SectionGroupDetail } from "../../../models/SectionGroupDetail";
import {
  BASIC_FILTERS,
  FORMS_FILTERS_LIST,
  SERVICE_TEMP_CONSTANTS,
  SERVICE_TEMP_EVENTS,
  SESSION_FILTERS_LIST
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ViewIframeModal from "@/shared/components/ViewIframeModal/ViewIframeModal.vue";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import _ from "lodash";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { FilterResultModel } from "@/modules/ServiceTemplate/models/FiltersResultModel";
import CardAddForm from "@/shared/components/CardAddForm/CardAddForm.vue";
import ChipFomList from "@/shared/components/ChipFomList/ChipFomList.vue";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { SESSION_TEMPLATES_ACCESS } from "@/modules/SessionTemplate/constants/SessionTemplateConstants";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { CupsPriceLevelFilter } from "@/modules/CupsPriceLevels/models/CupsPriceLevelFilter.model";
import { CupsPriceLevelHeader } from "@/modules/CupsPriceLevels/models/CupsPriceLevelHeader";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import { Utils } from "@/shared/utils/utils";
import SaveCupsPriceLevel from "@/modules/CupsPriceLevels/components/SaveCupsPriceLevel/SaveCupsPriceLevel.vue";

Vue.use(Vuetify);
@Component({
  name: "AddSectionGroup",
  components: {
    EmptyState,
    ViewIframeModal,
    FormModalViewer,
    CardAddForm,
    ChipFomList,
    GenericSearchBar,
    DynamicSelect,
    SaveCupsPriceLevel
  }
})
export default class AddSectionGroup extends Vue {
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;

  @Prop() dialog!: boolean;
  @Prop() private sectionGroupFill!: SectionGroup;
  @Prop() private sectionsGroups!: SectionGroup[];
  @Prop() title!: string;
  @Prop() iconsList!: [];
  @Prop() categoryList!: string[];
  @Prop() refreshSessionSearch!: number;
  @Prop() refreshFormSearch!: number;

  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  ADD_TITLE = SERVICE_TEMP_CONSTANTS.ADD_TEXT;
  EDIT_TITLE = SERVICE_TEMP_CONSTANTS.EDIT_TEXT;
  ICON_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.ICON;
  NAME_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.NAME_OF;
  CLUSTER_TEXT = SERVICE_TEMP_CONSTANTS.MODAL_TITLE.GROUP;
  SECTION_TEXT = SERVICE_TEMP_CONSTANTS.MODAL_TITLE.SECTION;
  SELECTED_TEXT = SERVICE_TEMP_CONSTANTS.SELECTED_FORMS;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  OPTIONS_INFO = "";
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;
  VIEW_BUTTON = FORM_CONSTANTS.BUTTON.VIEW;
  ADD_BUTTON = FORM_CONSTANTS.BUTTON.ADD;
  SEARCH_GROUP_ADDSECTIONGROUP_KEY = NAME_FINDERS.GROUP_ADDSECTIONGROUP;
  SEARCH_SECTION_ADDSECTIONGROUP_KEY = NAME_FINDERS.SECTION_ADDSECTIONGROUP;
  SEARCH_CUPS = SERVICE_TEMP_CONSTANTS.LABEL.SEARCH_CUPS;
  HINT_CUPS = SERVICE_TEMP_CONSTANTS.LABEL.HINT_CUPS;
  ACTIVE_LABEL = FORM_CONSTANTS.LABEL.STATE;
  COMPONENT_NAME_MODAL = COMPONENT_NAME_MODAL;

  cardClass = STYLE_CLASSES.CARD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  ELEMENT_INACTIVE = STYLE_CLASSES.ELEMENT_INACTIVE;
  rowForms = STYLE_CLASSES.ROW_FORMS;

  sectionGroup = new SectionGroup();
  formTempDataList: Array<FormStatus> = [];
  formTempDataListMatchName: Array<FormStatus> = [];
  filterQueryForms: QuerySend = {};
  filterQuerySessions: QuerySend = {};
  sectionGroupForm = false;
  openRoute = window;
  isEditing = false;
  loadingData = false;
  sessionsChosen = [];
  sessionFilterArray = SESSION_FILTERS_LIST;
  formsFilterArray = FORMS_FILTERS_LIST;
  sessionsItems: SearchFilter[] = BASIC_FILTERS.SESSION;
  formsItems: SearchFilter[] = BASIC_FILTERS.FORMS;
  sessionsFilterList: SectionGroupDetail[] = [];
  showCardsContainer = false;
  itemsByStepLabel = "";
  showMoreInfo = false;
  playbook = "";
  viewSessionDialog = false;
  viewFormTempDialog = false;
  clearModel = false;
  formTemplateData: FormTemplateData = new FormTemplateData();
  dateCreated = "";
  dateModified = "";
  formKey = 1;
  refreshFilters = false;
  addFormButton = false;
  addSessionButton = false;
  sessionDataListMatchName: SectionGroupDetail[] = [];
  lastFormRef = "";
  lastGroupRef = "";

  iconsServiceSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.iconsList,
    filled: false,
    messageLabel: this.ICON_LABEL,
    required: true,
    onlyIcon: true
  };

  cupsSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.SEARCH_CUPS,
    persistenthint: true,
    hint: this.HINT_CUPS,
    required: true,
    notFound: false,
    loadingData: true,
    chips: true
  };
  cupsSelectList: DynamicSelectData[] = [];
  listCups: CupsPriceLevelHeader[] = [];
  cupsLastRef = "";
  showModalAddCups = false;
  modalMessage = "";
  cupsInUse = "";

  listIconModel = [{ value: "", name: "" }];

  async mounted() {
    await this.open();
    this.$emit("scroll");
  }

  @Watch("title")
  async handleOnTitleChange() {
    await this.open();
  }

  @Watch("categoryList")
  handleCategoryList() {
    if (this.categoryList) {
      const mappedCategoryList = this.categoryList.map(item => ({
        key: item,
        name: item
      }));
      this.setCategoryList(mappedCategoryList);
    }
  }

  @Watch("sectionGroupFill")
  async open() {
    this.showCardsContainer = false;
    this.selectIcon = this.sectionGroupFill?.icon;

    if (this.sectionGroupFill?.name !== "") {
      this.isEditing = true;
    } else {
      this.isEditing = false;
      this.sectionGroupFill.itemsByStep = false;
    }

    if (this.title === SERVICE_TEMP_CONSTANTS.MODAL_TITLE.SECTION) {
      this.SELECTED_TEXT = SERVICE_TEMP_CONSTANTS.SELECTED_FORMS;
      this.itemsByStepLabel =
        SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.FILL_BY_STEP_LABEL +
        SERVICE_TEMP_CONSTANTS.FORMS.toLowerCase();
      this.OPTIONS_INFO = SERVICE_TEMP_CONSTANTS.LABEL.SELECT_FORMS;
    } else {
      this.SELECTED_TEXT = SERVICE_TEMP_CONSTANTS.SELECTED_SESSIONS;
      this.itemsByStepLabel =
        SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.FILL_BY_STEP_LABEL +
        SERVICE_TEMP_CONSTANTS.SESSIONS.toLowerCase();
      this.OPTIONS_INFO = SERVICE_TEMP_CONSTANTS.LABEL.SELECT_SESSIONS;
    }

    this.sectionGroup = _.cloneDeep(this.sectionGroupFill);
    this.cupsInUse = this.sectionGroup.cups ?? "";
    if (this.sectionGroup.cups) {
      await this.loadInactiveCups();
    }
    this.refreshFilters = true;
    this.resetForm();
  }

  get selectIcon() {
    return this.listIconModel[0].value;
  }

  set selectIcon(value: string) {
    const option = this.iconsServiceSelectConfig.listAll.find(
      (item: any) => item.value == value
    );
    this.listIconModel = [
      { value: option?.value ?? "", name: option?.name ?? "" }
    ];
  }

  get cupsChosen() {
    return this.cupsSelectList.length == 0
      ? new CupsPriceLevelHeader()
      : ((this.cupsSelectList[0] as unknown) as CupsPriceLevelHeader);
  }

  close() {
    this.$emit(SERVICE_TEMP_EVENTS.CLOSE_MODAL_ADD_SECTION_GROUP);
    this.clearForm();
  }

  save() {
    if (this.buildServiceValidator()) return;
    if (this.coincidencesServiceValidator()) return;

    this.sectionGroup.cups = this.cupsChosen?.id;

    if (this.isEditing) {
      this.$emit(
        SERVICE_TEMP_EVENTS.UPDATE_MODAL_ADD_SECTION_GROUP,
        this.sectionGroup
      );
    } else {
      this.sectionGroup.key = `s${nanoid(8)}t`;
      this.sectionGroup.order = this.sectionsGroups.length + 1;
      this.$emit(SERVICE_TEMP_EVENTS.SAVE_MODAL_ADD_SECTION_GROUP, {
        ...this.sectionGroup,
        icon: this.selectIcon
      });
    }
    this.clearForm();
  }

  buildServiceValidator() {
    if (
      this.sectionGroup.sessions?.length == 0 &&
      this.title === this.CLUSTER_TEXT
    ) {
      Snackbar.popWarning(
        SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.GROUP_WITHOUT_SESSION
      );
      return true;
    }
    if (
      this.sectionGroup.formTemplates?.length == 0 &&
      this.title === this.SECTION_TEXT
    ) {
      Snackbar.popWarning(
        SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.SECTION_WITHOUT_FORMS
      );
      return true;
    }
    return false;
  }

  coincidencesServiceValidator() {
    const sectionsFiltered = this.sectionsGroups.filter(
      section => section.key !== this.sectionGroup.key
    );

    const existSection =
      sectionsFiltered && sectionsFiltered.length > 0
        ? sectionsFiltered.find(
            section =>
              section.name.toUpperCase() ===
              this.sectionGroup.name.toUpperCase()
          )
        : undefined;

    if (existSection) {
      if (
        Object.keys(existSection).includes(
          SERVICE_TEMP_CONSTANTS.FORM_TEMPLATES
        )
      ) {
        Snackbar.popInfo(
          SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.SECTION_ALREADY_EXISTS
        );
        return true;
      }
      Snackbar.popInfo(
        SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.GROUP_ALREADY_EXISTS
      );
      return true;
    }
    return false;
  }

  clearForm() {
    this.sectionGroup = new SectionGroup();
    this.formTempDataList = [];
    this.sessionsFilterList = [];
    this.formsFilterArray = FORMS_FILTERS_LIST;
    this.sessionsItems.forEach(item => (item.value = ""));
    this.sessionsItems[0].active = true;
    this.refreshFilters = false;
  }

  resetForm() {
    this.formKey = 1 - this.formKey;
  }

  @Watch("refreshFormSearch")
  async searchTemplates(shouldPaginate?: boolean, shouldSearch?: boolean) {
    try {
      this.loadingData = true;
      this.filterQueryForms = {
        state: FORM_CONSTANTS.STATE.ACTIVE,
        paginatedResult: true
      };

      if (!shouldSearch) {
        this.showCardsContainer = false;
        this.loadingData = false;
        return;
      }

      if (this.lastFormRef) {
        this.filterQueryForms.docref = this.lastFormRef;
      }

      if (this.formsItems[0].value !== "")
        this.filterQueryForms.name = this.formsItems[0].value;

      if (this.formsItems[1].value !== "")
        this.filterQueryForms.category = this.formsItems[1].value;

      const formTempList = await this.formTemplateService.getFormTemplateWithFilters(
        this.filterQueryForms
      );

      if (formTempList.code === Http.Found && formTempList.data !== undefined) {
        const formList = formTempList.data.data;
        this.lastFormRef = formTempList.data.docref;
        if (shouldPaginate) {
          this.formTempDataList = [...this.formTempDataList, ...formList];
        } else {
          this.formTempDataList = formList;
        }
        if (this.filterQueryForms.name) {
          this.formTempDataListMatchName = this.formTempDataList.filter(
            item => item.name === this.filterQueryForms.name
          );
        } else {
          this.formTempDataListMatchName = this.formTempDataList;
        }
        this.showCardsContainer = true;
      } else {
        if (!shouldPaginate) {
          this.formTempDataListMatchName = [];
          this.formTempDataList = [];
        }
        if (formTempList.code === Http.NotFound)
          Snackbar.popInfo(FORM_MESSAGES.NOT_FOUND_TEMPLATES);
        else Snackbar.popError(formTempList.message);
      }

      this.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.loadingData = false;
      return Snackbar.popError(errorMessage);
    }
  }

  addForm(index: number) {
    const newFormTemp = {
      name: this.formTempDataList[index].name,
      id: this.formTempDataList[index]._key,
      icon: this.formTempDataList[index].icon,
      state: this.formTempDataList[index].state,
      multiple: this.formTempDataList[index].multiple
    };
    const existFormTemp = (this.sectionGroup
      .formTemplates as SectionGroupDetail[]).find(
      (formTemp: SectionGroupDetail) =>
        formTemp.id === this.formTempDataList[index]._key
    );

    if (!existFormTemp) {
      (this.sectionGroup.formTemplates as SectionGroupDetail[]).push(
        newFormTemp
      );
      return Snackbar.popSuccess(SERVICE_TEMP_CONSTANTS.MESSAGES.ADD_FORM);
    } else {
      return Snackbar.popInfo(SERVICE_TEMP_CONSTANTS.MESSAGES.EXIST_FORM);
    }
  }

  removeForm(index: number) {
    this.sectionGroup.formTemplates?.splice(index, 1);
  }

  @Watch("refreshSessionSearch")
  async searchSession(shouldPaginate?: boolean, shouldSearch?: boolean) {
    this.loadingData = true;
    this.filterQuerySessions = {
      state: FORM_CONSTANTS.STATE.ACTIVE,
      paginatedResult: true
    };

    if (!shouldSearch) {
      this.showCardsContainer = false;
      this.loadingData = false;
      return;
    }

    if (this.lastGroupRef) {
      this.filterQuerySessions.idReference = this.lastGroupRef;
    }

    try {
      if (this.sessionsItems[0].value !== "")
        this.filterQuerySessions.name = this.sessionsItems[0].value;

      const sessionList = await this.serviceTemplateService.getSessionsByFilters(
        this.filterQuerySessions
      );

      if (sessionList.code === Http.Found && sessionList.data !== undefined) {
        const sessionsList = sessionList.data.sessionTemplates;
        this.lastGroupRef = sessionList.data.docref;
        if (shouldPaginate) {
          this.sessionsFilterList = [
            ...this.sessionsFilterList,
            ...sessionsList
          ];
        } else {
          this.sessionsFilterList = sessionsList;
        }

        if (this.filterQuerySessions.name) {
          this.sessionDataListMatchName = this.sessionsFilterList.filter(
            item => item.name === this.filterQueryForms.name
          );
        } else {
          this.sessionDataListMatchName = this.sessionsFilterList;
        }
        this.showCardsContainer = true;
      } else {
        if (!shouldPaginate) {
          this.sessionDataListMatchName = [];
          this.sessionsFilterList = [];
        }
        Snackbar.popInfo(sessionList.message);
      }

      this.loadingData = false;
    } catch (error) {
      this.loadingData = false;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SESSION_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      return Snackbar.popError(errorMessage);
    }
  }

  addSession(index: number) {
    const existSession = (this.sectionGroup
      .sessions as SectionGroupDetail[]).find(
      session => session.id === this.sessionsFilterList[index].id
    );

    if (!existSession) {
      (this.sectionGroup.sessions as SectionGroupDetail[]).push(
        this.sessionsFilterList[index]
      );
      return Snackbar.popSuccess(SERVICE_TEMP_CONSTANTS.MESSAGES.ADD_SESSION);
    } else {
      return Snackbar.popInfo(SERVICE_TEMP_CONSTANTS.MESSAGES.EXIST_SESSION);
    }
  }

  removeSession(index: number) {
    this.sectionGroup.sessions?.splice(index, 1);
  }

  viewSessionTemp(playbook: string) {
    this.playbook = playbook;
    this.viewSessionDialog = true;
  }

  closeIframe() {
    this.viewSessionDialog = false;
  }

  async viewFormTemp(id: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        id
      );

      if (response.code === Http.Found && response.data != null) {
        this.formTemplateData = response.data;

        this.dateCreated = this.formTemplateData.dateCreated
          ? new Date(this.formTemplateData.dateCreated).toLocaleString("es-CO")
          : "";

        this.dateModified = this.formTemplateData.dateChanged
          ? new Date(this.formTemplateData.dateChanged).toLocaleString("es-CO")
          : "";

        this.viewFormTempDialog = true;
        this.clearModel = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  closeModalPreview() {
    this.viewFormTempDialog = false;
    this.clearModel = false;
  }

  async getSessionFilterEvents(data: FilterResultModel) {
    delete data["mainFilterKey"];

    if (data.name) {
      this.sessionsItems[0].value = data.name[0];
    } else {
      this.sessionsItems[0].value = "";
    }
    this.addSessionButton = true;
    this.lastGroupRef = "";
    await this.searchSession(false, true);
  }

  async getFormsFilterEvents(data: FilterResultModel) {
    delete data["mainFilterKey"];

    if (data.name) {
      this.formsItems[0].value = data.name[0];
    } else {
      this.formsItems[0].value = "";
    }

    if (data.category) {
      this.formsItems[1].value = data.category[0];
    } else {
      this.formsItems[1].value = "";
    }
    this.addFormButton = true;
    this.lastFormRef = "";
    await this.searchTemplates(false, true);
  }

  setCategoryList(list: List[]) {
    this.formsFilterArray[0].secondaryFilters[1].options = list;
  }

  addItem() {
    this.$emit(SERVICE_TEMP_CONSTANTS.ADD_ITEM, this.title);
  }

  async onBottomFormsScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchTemplates(true, true);
    }
  }
  async onBottomGroupScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchSession(true, true);
    }
  }

  addCupsElement() {
    this.showModalAddCups = true;
  }

  async handleCups(name: string, newCups?: boolean) {
    this.cupsSelectConfig.loadingData = true;
    this.cupsSelectConfig.notFound = false;
    const responseData = await this.cupsPriceLevelService.getCupsPriceLevelByFilter(
      { externalName: name, statesList: [this.ACTIVE_LABEL] }
    );

    this.cupsSelectConfig.notFound = responseData.code === Http.NotFound;
    if (responseData.code === Http.Found && responseData.data) {
      await this.getCupsList();
      const SearchCups = responseData.data.cupsPriceLevels.map(item => {
        return {
          clients: item.clients,
          cups: item.cups,
          id: item.id,
          name: item.externalName,
          requiredPriorOrder: item.requiredPriorOrder,
          state: item.state
        };
      });

      this.cupsSelectConfig.listAll = [
        ...this.cupsSelectConfig.listAll,
        ...SearchCups
      ];
      if (newCups) {
        this.cupsSelectList = [
          {
            id: responseData.data.cupsPriceLevels[0].id,
            name: responseData.data.cupsPriceLevels[0].externalName,
            state: responseData.data.cupsPriceLevels[0].state
          }
        ];
      }
    } else {
      this.cupsSelectConfig.notFound = true;
    }
    this.cupsSelectConfig.loadingData = false;
  }

  async getCupsList(name?: string) {
    try {
      const query: CupsPriceLevelFilter = {
        statesList: [this.ACTIVE_LABEL],
        paginatedResult: true,
        docref: this.cupsLastRef
      };

      if (name) {
        await this.handleCups(name);
        return;
      }

      const responseData = await this.cupsPriceLevelService.getCupsPriceLevelByFilter(
        query
      );
      if (this.cupsSelectConfig.notFound) return;
      if (responseData.code === Http.Found && responseData.data) {
        if (this.cupsLastRef) {
          this.listCups = [
            ...this.listCups,
            ...responseData.data.cupsPriceLevels
          ];
        } else {
          this.listCups = responseData.data.cupsPriceLevels;
        }
        this.cupsLastRef = responseData.data.docref;
        this.cupsSelectConfig.listAll = this.listCups as [];
      } else {
        this.listCups = [];
        this.cupsSelectConfig.notFound = responseData.code === Http.NotFound;
      }
      this.cupsSelectConfig.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      this.listCups = [];
      this.cupsSelectConfig.listAll = [];
    }
  }

  onClosePriceLevelModal(refreshList: boolean) {
    this.showModalAddCups = false;
    this.modalMessage = "";
    if (refreshList) this.getCupsList();
  }

  closeOptionsModal(modal: string) {
    this.modalMessage = modal;
    const modalUserTemplate: SearchContextModal = {
      componentName: modal,
      callbackHandleOperation: this.handleOperation
    };
    Utils.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  async handleOperation(action: string) {
    if (action === LIST_DATA_EVENTS.CANCEL_DATA) {
      switch (this.modalMessage) {
        case COMPONENT_NAME_MODAL.CUPS_PRICE_LEVEL:
          this.onClosePriceLevelModal(false);
          break;
      }
    }
  }

  closeOnSave(modal: string) {
    switch (modal) {
      case COMPONENT_NAME_MODAL.CUPS_PRICE_LEVEL:
        this.onClosePriceLevelModal(true);
        break;
    }
  }

  eventServiceCups(name: string, payload: boolean) {
    if (name && payload === true) {
      this.handleCups(name, payload as boolean);
    }
  }

  async loadInactiveCups() {
    try {
      const inactiveCups = this.listCups.find(
        cups => cups.id === this.cupsInUse
      )?.id;

      if (!inactiveCups) {
        const response = await this.cupsPriceLevelService.getCupsPriceLevelById(
          this.cupsInUse
        );

        if (response.code === Http.Found && response.data !== undefined) {
          this.cupsSelectConfig.listAll.push(({
            id: response.data.id,
            name: response.data.externalName,
            state: response.data.state
          } as unknown) as DynamicSelectData);
          this.cupsSelectList = [
            {
              id: response.data.id!,
              name: response.data.externalName,
              state: response.data.state
            }
          ];
        }
      }
    } catch (err) {
      return [];
    }
  }
}
